import Day1 from './components/day1/day';
import Day2 from './components/day2/day';
import Day3 from './components/day3/day';
import Day4 from './components/day4/day';
import Day5 from './components/day5/day';
import Day6 from './components/day6/day';
import Day7 from './components/day7/day';
import Day8 from './components/day8/day';
import Day9 from './components/day9/day';
import Day10 from './components/day10/day';
import Day11 from './components/day11/day';
import Day12 from './components/day12/day';
import Day13 from './components/day13/day';
import Day14 from './components/day14/day';
import Day15 from './components/day15/day';
import Day16 from './components/day16/day';
import Day17 from './components/day17/day';
import Day18 from './components/day18/day';
import Day19 from './components/day19/day';
import Day20 from './components/day20/day';
import Day21 from './components/day21/day';
import Day22 from './components/day22/day';
import Day23 from './components/day23/day';
import Day24 from './components/day24/day';
import Day25 from './components/day25/day';
import Day26 from './components/day26/day';
import Day27 from './components/day27/day';
import Day28 from './components/day28/day';
import Day29 from './components/day29/day';
import Day30 from './components/day30/day';
import Day31 from './components/day31/day';
import Day32 from './components/day32/day';
import Day33 from './components/day33/day';
import Day34 from './components/day34/day';

export const days = {
  1: Day1,
  2: Day2,
  3: Day3,
  4: Day4,
  5: Day5,
  6: Day6,
  7: Day7,
  8: Day8,
  9: Day9,
  10: Day10,
  11: Day11,
  12: Day12,
  13: Day13,
  14: Day14,
  15: Day15,
  16: Day16,
  17: Day17,
  18: Day18,
  19: Day19,
  20: Day20,
  21: Day21,
  22: Day22,
  23: Day23,
  24: Day24,
  25: Day25,
  26: Day26,
  27: Day27,
  28: Day28,
  29: Day29,
  30: Day30,
  31: Day31,
  32: Day32,
  33: Day33,
  34: Day34,
}